import { CheckboxGroup } from "@/components/FilterableCheckboxGroupDropdown";
import { ExportDropdown } from "./ExportDropdown";
import { RefreshButton } from "./RefreshButton";
import { ShareButton } from "./ShareButton";
import { useColumnGroups, ViewColumnsDropdown } from "./ViewColumnsDropdown";
import { ListToolbarProps } from "@/types/list";

type ListToolbarActionsProps<TData> = Pick<
	ListToolbarProps<TData>,
	"table" | "tableName" | "loading" | "expandedRowPanelExport" | "refreshFunction" | "actionCoppyUrl"
>;

export const ListToolbarActions = <TData,>({
	table,
	tableName,
	loading = false,
	expandedRowPanelExport,
	refreshFunction,
	actionCoppyUrl = false,
}: ListToolbarActionsProps<TData>) => {
	const { columnGroups, updateVisibility, setManyVisibilities } = useColumnGroups(table);

	const groups: CheckboxGroup[] = columnGroups.map(({ label, children }) => ({
		name: label,
		items: children.map(item => ({
			id: item.id,
			name: item.label,
			checked: item.visible,
		})),
	}));

	const onToggleAll = (checked: boolean) => {
		const vis = Object.fromEntries(columnGroups.flatMap(group => group.children.map(col => [col.id, checked])));
		setManyVisibilities(vis);
	};

	return (
		<div className="flex items-end gap-2 md:ml-auto shrink-0">
			<ExportDropdown
				loading={loading}
				tableName={tableName}
				table={table}
				expandedRowPanelExport={expandedRowPanelExport}
			/>

			<ViewColumnsDropdown
				groups={groups}
				onCheckedChange={updateVisibility}
				onToggleAll={onToggleAll}
				loading={loading}
			/>

			{actionCoppyUrl && <ShareButton />}

			{refreshFunction && (
				<RefreshButton onClick={refreshFunction} loading={loading} tooltip="Refresh table" withTooltip />
			)}
		</div>
	);
};
